<template>
  <button @click="toggleLanguage" class="lang-btn">
    {{ isChinese ? "En" : "中" }}
  </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LanguageChange',
  data() {
    return {};
  },
  computed: {
    // 从 Vuex 获取当前语言状态
    ...mapGetters('user', ['currentLanguage', 'isChinese']),
    currentLang() {
      return this.currentLanguage
    }
  },
  methods: {
    // 映射 Vuex actions
    ...mapActions('user', ['toggleLanguage', 'setLanguage']),
    
    // 如果需要自定义逻辑，可以这样写
    async switchLanguage() {
      try {
        // 调用 Vuex action 切换语言
        await this.toggleLanguage()
        
        // 切换成功后的操作
        this.$toast.success(
          this.currentLang === 'zh' 
            ? '已切换为中文' 
            : 'Switched to English'
        )
        
        // 如果需要刷新页面内容，可以触发事件让父组件处理
        this.$emit('language-changed', this.currentLang)
        
        // 或者重新加载页面（简单粗暴）
        // window.location.reload()
        
      } catch (error) {
        console.error('切换语言失败:', error)
        this.$toast.error('切换语言失败')
      }
    }
  }
};
</script>

<style scoped>
.lang-btn {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #f9fafb;
  font-size: 0.75rem;
  font-weight: 700;
  color: #0057FF;
  border: 1px solid #f3f4f6;
}
</style>